import { render, staticRenderFns } from "./ActiveCourse.vue?vue&type=template&id=32680f80&"
import script from "./ActiveCourse.vue?vue&type=script&lang=js&"
export * from "./ActiveCourse.vue?vue&type=script&lang=js&"
import style0 from "./ActiveCourse.vue?vue&type=style&index=0&id=32680f80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports